import Experiment from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { getPageSource, track } from '@mc/track-event'
import { TrackingContainer } from '@mc/visibility'
import { trackNavigationClick } from 'components/Footer/kinds/events'
import Link from 'components/Link'
import { MEMBER_WINS_IN_FOOTER_FLAG_NAME } from './constants'
import { MEMBER_WINS_IN_FOOTER_I18N_NAMESPACE } from './i18n'

export const MemberWinsInFooterExp = () => (
  <TrackingContainer
    onFirstVisible={() =>
      track('Footer Viewed', { page_source: getPageSource() })
    }
  >
    <Experiment
      name={MEMBER_WINS_IN_FOOTER_FLAG_NAME}
      default={() => null}
      variant_1={Variant}
    />
  </TrackingContainer>
)

const Variant = () => {
  const { t } = useTranslation(MEMBER_WINS_IN_FOOTER_I18N_NAMESPACE)

  return (
    <li className='mc-mb-5 mc-pb-1'>
      <Link
        href={paths.memberWins}
        className='mc-text--bare-link'
        passHref
        onClick={() => trackNavigationClick(t('memberWins'))}
      >
        {t('memberWins')}
      </Link>
    </li>
  )
}
